import {request} from '@/network/request'

// export function fetchList(query) {
//   return request({
//     url: '/gaoligong/gaoligongdirectory/page',
//     method: 'get',
//     params: query
//   })
// }
//
// export function addObj(obj) {
//   return request({
//     url: '/gaoligong/gaoligongdirectory',
//     method: 'post',
//     data: obj
//   })
// }
//
// export function getObj(id) {
//   return request({
//     url: '/gaoligong/gaoligongdirectory/' + id,
//     method: 'get'
//   })
// }
//
// export function delObj(id) {
//   return request({
//     url: '/gaoligong/gaoligongdirectory/' + id,
//     method: 'delete'
//   })
// }
//
// export function putObj(obj) {
//   return request({
//     url: '/gaoligong/gaoligongdirectory',
//     method: 'put',
//     data: obj
//   })
// }
export function fetchList(data) {
  return request({
    url: '/gaoligong/riskplantdirectory/getRiskPlantDirectoryList',
    method: 'post',
    data:data
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/riskplantdirectory',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/riskplantdirectory/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/riskplantdirectory/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/riskplantdirectory',
    method: 'put',
    data: obj
  })
}
